






import { Component, Vue } from 'vue-property-decorator';
import LoginForm from '@/components/Login.vue'

@Component({
  components: {
    LoginForm
  }
})
export default class Login extends Vue {

}
